import { HackerStage } from "../HackerContext/types";

export const hasAttendeeEventAccess = (
  attendeeFound: boolean | null,
  stage: HackerStage | undefined
): boolean =>
  attendeeFound === true &&
  (stage === HackerStage.CONFIRMED || stage === HackerStage.CHECKED_IN);

export const hasSponsorEventAccess = (
  isSponsor: boolean,
  stage: HackerStage | undefined
): boolean =>
  isSponsor &&
  (stage === HackerStage.CONFIRMED || stage === HackerStage.CHECKED_IN);

export const hasMentorEventAccess = (
  isMentor: boolean,
  stage: HackerStage | undefined
): boolean =>
  isMentor &&
  (stage === HackerStage.CONFIRMED || stage === HackerStage.CHECKED_IN);

export const hasWorkshopLeadEventAccess = (
  isWorkshopLead: boolean,
  stage: HackerStage | undefined
): boolean =>
  isWorkshopLead &&
  (stage === HackerStage.CONFIRMED || stage === HackerStage.CHECKED_IN);

/** Volunteers may use shift tools only after completing RSVP (same stages as hackers). */
export const hasVolunteerEventAccess = (
  isVolunteer: boolean,
  stage: HackerStage | undefined
): boolean =>
  isVolunteer &&
  (stage === HackerStage.CONFIRMED || stage === HackerStage.CHECKED_IN);
